<template>
  <div class="bg-white border-radius-lg">
    <highcharts
      :options="computedOptions"
      class="border-radius-lg p-1"
      style="height: 100dvh;"
    ></highcharts>
  </div>
</template>

<script>
export default {
  name: "ChartProductosPie",
  props: {
    seriesData: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: "Productos"
    },
    subtitle: {
      type: String,
      default: "Cantidad de Productos Vendidos"
    }
  },
  computed: {
    computedOptions() {
      return {
        chart: { type: 'pie' },
        title: { text: this.title },
        tooltip: { valueSuffix: '' },
        subtitle: { text: this.subtitle },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                showInLegend: true,
                dataLabels: [
                  {
                    enabled: true,
                    distance: 20,
                    format: '<b>{point.name}:</b> <span style="opacity: 0.5">' + '{y}</span>',
                  },
                  {
                    enabled: true,
                    distance: -40,
                    format: '{point.y:.0f}',
                    style: {
                        fontSize: '0.8em',
                        textOutline: 'none',
                        opacity: 0.7
                    },
                    filter: {
                        operator: '>',
                        property: 'y',
                        value: 8
                    }
                  }
                ]
            }
        },
        colors: [
                    '#4F2DA3',
                    '#7B41B6',
                    '#B850CD',
                    '#F6D7DE',
                    '#E895BE',
                    '#CCC1E4',
                    '#9444BC',
                    '#EA69D4'
                ],
        series: [
            {
                name: 'Total Ventas',
                colorByPoint: true,
                data: this.seriesData
            }
        ]
      };
    }
  }
};
</script>